module.exports = __webpack_public_path__ + "static/assets/e7f277894b630e4518b9ae03229f875a.png";